import { HTTP } from '../../core/http/http-token';
import Routing from '../../core/router/router';

const state = {
  dispositions: [],
  idDispo: [],
  all: [],
  selectedIds: [],
  selectedDispositions: [],
  loading: false,
  currentPage: 1,
  nbPerPage: 8,
  endReached: false,
  currentDisposition: '',
  defaultDisposition: [],
};

function pushIdDispo(state, disposition) {
  state.idDispo.push(disposition);
}

function saveDisposition(dispo) {
  var data = {};
  var icon = document.getElementById('icon-add-dispo');
  var icon2 = document.getElementById('icon-add-dispo-load');
  var btnAdd = document.getElementById('success-dispo');
  btnAdd.style.display = 'none';
  // element.classList.add("mystyle");
  /*Todo change api save dispo*/
  data = { screenToSubmit: dispo };

  HTTP(window.ApiToken)
    .post(Routing.generate('api_screenDisplay_post_add_edit_screen'), {
      data: data,
      client: 'demo',
    })
    .then(function(response) {
      if (response.data.code === 200) {
        pushIdDispo(state, response.data.id);
        icon.style.display = 'inline-block';
        icon2.style.display = 'none';
        btnAdd.style.display = 'block';
        let toast = self.$toasted.show('Disposition ajoutée avec succès', {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 4000,
        });
        setTimeout(function() {
          var btnAdd = document.getElementById('success-dispo');
          btnAdd.style.display = 'block';
          var btnAddLoad = document.getElementById('success-dispo-loading');
          btnAddLoad.style.display = 'none';
        }, 2000);
      }
    });
}

const mutations = {
  setDispositions(state, data) {
    state.dispositions = data;
  },
  setSelectedDispositionsIds(state, data) {
    state.selectedIds = data;
  },
  setSelectedDispositions(state, data) {
    state.selectedDispositions = data;
  },
  setDispositionByIndex(state, data) {
    state.dispositions[data.index] = data.disposition;
  },
  pushDispositions(state, disposition) {
    state.all = state.all.concat(disposition);
  },
  duplicateDisposition(state, dispositions) {
    state.selectedDispositions = state.selectedDispositions.concat(dispositions);
  },
  selectDisposition(state, dispositionId) {
    if (state.selectedIds.includes(dispositionId)) {
      state.selectedIds = state.selectedIds.filter(s => s !== dispositionId);
    } else {
      state.selectedIds.push(dispositionId);
      const item = state.all.find(item => item.id === dispositionId);
      item.options = { duration: 20000 };
      item.transition = { in: '', out: '' };
      state.selectedDispositions.push(item);
    }
  },
  setLoading(state, loading) {
    state.loading = loading;
  },

  incrementPage(state) {
    state.currentPage += 1;
  },

  setEndReached(state, endReached) {
    state.endReached = endReached;
  },
  unshiftDisposition(state, disposition) {
    state.dispositions.unshift(disposition);
  },
  addDisposition(state, disposition) {
    //state.dispositions.push(disposition);

    saveDisposition(disposition);
    localStorage.setItem('component', disposition.components);
    localStorage.setItem('style', disposition.styles);
  },
  deleteDispositionsById(state, id) {
    state.selectedDispositions = state.selectedDispositions.filter(item => item.id !== id);
  },
  /**
   *
   * @function updateDispositionTitle
   */
  updateDispositionTitle(state, title) {
    var index = state.dispositions.findIndex(item => title.oldTitle == item.title);
    state.dispositions[index].title = title.newTitle;
    HTTP(window.ApiToken)
      .post(
        Routing.generate('api_screenDisplay_edit_title_disposition', {
          id: state.dispositions[index].id,
        }),
        {
          title: title.newTitle,
        },
      )
      .then(function(response) {
        if (response.data.code === 200) {
        }
      });
  },
};
const actions = {
  async paginateDispositions({ commit }) {
    commit('setLoading', true);
    const url = Routing.generate('api_screenDisplay_get_all_disposition', {
      page: state.currentPage,
      nbParPage: state.nbPerPage,
      type: 'Disposition',
      client: localStorage.getItem('client'),
    });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(function(response) {
          resolve(response);
        });
    });

    commit('pushDispositions', data.data.dispositions);

    commit('incrementPage');
    if (data.data.dispositions.length === 0) {
      commit('setEndReached', true);
    }
    commit('setLoading', false);
  },
  selectDisposition: ({ state, commit }, dispositionId) =>
    commit('selectDisposition', dispositionId),
  setDispositions: ({ state, commit }, dispositions) => commit('setDispositions', dispositions),
  deleteDispositionsById: ({ state, commit }, dispositions) =>
    commit('deleteDispositionsById', dispositions),
  setSelectedDispositionsIds: ({ state, commit }, dispositions) =>
    commit('setSelectedDispositionsIds', dispositions),
  setSelectedDispositions: ({ state, commit }, dispositions) =>
    commit('setSelectedDispositions', dispositions),
  addDisposition: ({ state, commit }, disposition) => commit('addDisposition', disposition),
  duplicateDisposition: ({ state, commit }, disposition) =>
    commit('duplicateDisposition', disposition),
  pushDispositions: ({ state, commit }, disposition) => commit('pushDispositions', disposition),
  unshiftDisposition: ({ state, commit }, disposition) => commit('unshiftDisposition', disposition),
  pushIdDispo: ({ state, commit }, disposition) => commit('pushIdDispo', disposition),
  setDispositionByIndex: ({ state, commit }, data) => commit('setDispositionByIndex', data),
  updateDispositionTitle: ({ state, commit }, title) => commit('updateDispositionTitle', title),
};
const getters = {
  getLoading: state => state.loading,
  getEndReached: state => state.endReached,
  getAll: state => state.all,
  getSelectedIds: state => state.selectedIds,
  getSelectedDispositions: state => state.selectedDispositions,
  getDispositionPerId: state => id => {
    var disposition = state.all.filter(item => item.id === id);
    return disposition;
  },
  getDefaultDisposition: state => state.defaultDisposition,
  getCurrentDisposition: state => state.currentDisposition,
  getTemplateTitle: state => state.templateTitle,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/dispositions-data.js